import { z } from 'zod';

export const SearchSchema = z.object({
  status: z
    .enum(['all', 'pending', 'in_progress', 'completed', 'rejected'])
    .default('pending')
    .catch('pending'),
  selectedId: z.string().optional().catch(undefined),
  page: z.number().int().min(1).default(1).catch(1),
  pageSize: z.number().int().min(1).default(20).catch(20),
});
